import { FiltersSection } from '../interaction/FiltersSection';
import { ReceptionFilters } from '../../models/Reception';

interface ReceptionsHeaderProps {
  filters: ReceptionFilters;
  onFiltersChange: (filters: ReceptionFilters) => void;
  onSearch: (term: string) => void;
  searchTerm: string;
  total: number;
}

/**
 * Cabecera de la lista de recepciones con filtros y contador
 */
export const ReceptionsHeader: React.FC<ReceptionsHeaderProps> = ({
  filters,
  onFiltersChange,
  onSearch,
  searchTerm,
  total,
}) => {
  return (
    <div className="mb-2">
      <FiltersSection
        filters={filters}
        onFiltersChange={onFiltersChange}
        onSearch={onSearch}
        searchTerm={searchTerm}
        total={total}
      />
    </div>
  );
};

export default ReceptionsHeader;

